type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  loaded?: boolean
  version?: string
  push?: MetaPixel
}

declare global {
  interface Window {
    fbq?: MetaPixel
    _fbq?: MetaPixel
  }
}

export const META_PIXEL_ID = '2867112420320002'

let initialized = false

export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined') return

  if (initialized) return
  initialized = true

  if (window.fbq) {
    window.fbq('track', 'PageView')
    return
  }

  const fbq: MetaPixel = (...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
      return
    }
    fbq.queue?.push(args)
  }

  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  fbq('init', pixelId)
  fbq('track', 'PageView')
}
